export const options = [
  {
    label: 'StempleAlangoSkigayZiamangdaTora',
    value: 'StempleAlangoSkigayZiamangdaTora',
    desc: 'China Sample (中国)',
  },
  {
    label: 'HanagaIasVuiFyStempleAlangoSkigayZiamangdaTora',
    value: 'HanagaIasVuiFyStempleAlangoSkigayZiamangdaTora',
    desc: 'USA Sample (美国)',
  },
  {
    label: 'JapagunibStempleAlangoSkigayZiamangdaToraLgiyu',
    value: 'JapagunibStempleAlangoSkigayZiamangdaToraLgiyu',
    desc: 'Japan Sample (日本)',
  },
  {
    label: 'IndatasoStempleAlangoSkigayZiamangdaToraYgnfa',
    value: 'IndatasoStempleAlangoSkigayZiamangdaToraYgnfa',
    desc: 'Korea Sample (韩国)',
  },
]

export const items = [
  {
    value: '+1',
    label: '+1',
  },
]

export const roleOptions = [
  { label: 'Role 1', value: '3fa85f64-5717-4562-b3fc-2c963f66afa6' },
  { label: 'Role 2', value: '3fa85f64-5717-4562-b3fc-2c963f66afa5' },
  { label: 'Role 3', value: '3fa85f64-5717-4562-b3fc-2c963f66afa4' },
  { label: 'Role 4', value: '3fa85f64-5717-4562-b3fc-2c963f66afa3' },
  { label: 'Role 5', value: '3fa85f64-5717-4562-b3fc-2c963f66afa2' },
]
